import {
  acceptanceParentServiceId,
  calendarTypeIds,
} from '../constants/requests.constants';
import request from '../helpers/request';

const getRequestCalendarType = async ({
  requestId,
  requestParentServiceId,
}) => {
  const calendarType = await request.get(
    `/Request/calendar_type`,
    { requestId },
    `При получении типа календаря произошла ошибка`,
    'Error',
    undefined,
    undefined,
    {},
    true
  );

  if (calendarType && calendarType !== 'Error') {
    return calendarType;
  } else {
    return requestParentServiceId === acceptanceParentServiceId
      ? calendarTypeIds.acceptance
      : calendarTypeIds.common;
  }
};

export default getRequestCalendarType;
